var render = function render(){var _vm=this,_c=_vm._self._c;return _c('selector',{attrs:{"selected":_vm.value,"options":_vm.trip_types,"onChange":(v) => _vm.select_trip_type(v),"extra_style":{
    '--button-min-width': '168px',
  },"showDividers":"","compact":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }